import React from 'react';

export const PAGE_SIZE = 40;

export class DelayedList extends React.Component {
	state = {};

	componentDidMount() {
		setTimeout(this.showAllItems, 100);
	}

	componentWillUnmount() {
		this.componentUnmounted = true;
	}

	showAllItems = () => {
		if (!this.componentUnmounted) {
			this.setState({ showAll: true });
		}
	};

	render() {
		const { list, children } = this.props;
		const { showAll } = this.state;

		const listLength = list.length;
		const page = showAll ? listLength : PAGE_SIZE;

		return <React.Fragment>{list.slice(0, page).map(children)}</React.Fragment>;
	}
}
